import React, { useEffect, useState } from 'react'
import { InsomnioCatalog, InsomnioOptions, insomniCatalog2 } from './insomnio.catalog'
import { Button, Card, Form, message, Radio } from 'antd';
import { CardHeader, checkEncuesta, EncuestaLoading, InfoCard, NameLabel, onFinishFailed, ThanksMessage } from '../utils';
import { sendDataBody } from '../../resources';

export default function InsomnioEncuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default' }) {


    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'insomnio', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }



    const onFinish = (values) => {
        console.log('Orginal values: ', values)
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            insomnio: Object.values(values),
            tipo: 'insomnio',
            uuid: token,
            visita: visita,
            sesion: session,
            protocolo: protocolo
        }
        console.log('Body:', body);
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };





    const onChange = (e) => {
        console.log('radio checked', e.target.value);
    };

    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage />

    return (
        <div className='parentContainer'>
            <CardHeader title="Escala de gravedad del insomnio (IGS)">
                <NameLabel pacienteData={pacienteData} />

                <NameLabel pacienteData={medicoData} label="Médico: " />

                <InfoCard label="Sesión" value={session} />
            </CardHeader>
            <div className='formContainer'>



                <p>El índice de gravedad del insomnio tiene siete preguntas. Las siete respuestas se suman para obtener una puntuación total. Cuando tenga su puntuación total, consulte las 'Pautas para la puntuación/interpretación' a continuación para ver dónde encaja su dificultad para dormir.

                    Para cada pregunta, encierre en un círculo el número que mejor describa su respuesta. Califique la GRAVEDAD ACTUAL (es decir, LAS ÚLTIMAS 2 SEMANAS) de su(s) problema(s) de insomnio. </p>

                <Form
                    layout='vertical'
                    name="gad7_enc"
                    // labelCol={{ span: 24 }}
                    // wrapperCol={{ span: 24 }}
                    initialValues={[]}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >

                    {
                        InsomnioCatalog.map((item, index) => (
                            <Form.Item
                                label={item}
                                name={index}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Seleccione una respuesta',
                                    },
                                ]}
                            >
                                <Radio.Group onChange={onChange} >

                                    {
                                        InsomnioOptions.map((option) => (
                                            <Radio key={option.value} value={option.value}>
                                                {option.label}
                                            </Radio>
                                        ))

                                    }
                                </Radio.Group>
                            </Form.Item>
                        ))
                    }

                    {
                        insomniCatalog2.map((item, index) => (
                            <Form.Item
                                label={item.label}
                                name={index + InsomnioCatalog.length}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Seleccione una respuesta',
                                    },
                                ]}
                            >
                                <Radio.Group>
                                    {item.responses.map((response, i) => (
                                        <Radio key={i} value={i}>{response}</Radio>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        ))
                    }

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button form='gad7_enc' type="primary" htmlType="submit">
                            Enviar respuestas
                        </Button>
                    </Form.Item>
                    {/* <Button type='primary' onClick={navToUrl} style={{ alignSelf: 'center' }}>Siguiente</Button> */}
                </Form>
            </div >
        </div>
    )
}
